fragment lightBarMitzvahDetails on BarMitzvahType {
  student {
    id
    email
    username
    firstName
    lastName
  }
  date
  hidden
  kippahReminder
  practiceTracking
}
